export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5096.c2575bd5.jpg";